export const GET_ORGANIZATIONAL_COMMITMENT_SUCCESS =
  'GET_ORGANIZATIONAL_COMMITMENT_SUCCESS';
export const GET_ORGANIZATIONAL_COMMITMENT_FAILURE =
  'GET_ORGANIZATIONAL_COMMITMENT_FAILURE';

export const POST_ORGANIZATIONAL_COMMITMENT_SUCCESS =
  'POST_ORGANIZATIONAL_COMMITMENT_SUCCESS';
export const POST_ORGANIZATIONAL_COMMITMENT_FAILURE =
  'POST_ORGANIZATIONAL_COMMITMENT_FAILURE';
